module.exports = __webpack_public_path__ + "static/media/gen_img54.8ca94d28.png";